module.exports = __webpack_public_path__ + "static/media/support.66bd4f13.png";